import { TarifasGruaService } from './../../services/tarifa-grua-service';
import { TarifaGruaDto } from './../../models/tarifaGruaDto.model';
import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { FormService } from 'path-shared/services/form/form.service';
import { Builder } from 'path-shared/models/builder';
import { VehiclesService } from 'app/sections/ciutat/vehicles/services/vehicles.service';
import { ComboBoxInputComponent } from 'path-shared/components/form/combo-box-input/combo-box-input.component';
import { BehaviorSubject } from 'rxjs';
import { Dictionary } from 'path-shared/models/dictionary';


@Component({
  selector: 'app-tarifas-grua-editor',
  templateUrl: './tarifas-grua-editor.component.html',
  styleUrls: ['./tarifas-grua-editor.component.scss']
})
export class TarifasGruaEditorComponent implements OnInit {
  secure_id: string;
  tarifaGrua: TarifaGruaDto;
  dialogData: ComponentDialog;
  tipusVehicleDictionary: BehaviorSubject<Array<Dictionary>>;
  tipusEstanciaDictionary: BehaviorSubject<Array<Dictionary>>;
  tipusTarifaDictionary: BehaviorSubject<Array<Dictionary>>;
  closeButtonText: string;
  @ViewChild('mainForm') private mainForm: ElementRef;
  @ViewChild('comboTipusVehicle') comboTipusVehicle: ComboBoxInputComponent;
  @ViewChild('comboTipusEstancia') comboTipusEstancia: ComboBoxInputComponent;
  @ViewChild('comboTipusTarifa') comboTipusTarifa: ComboBoxInputComponent;
  constructor( private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private tarifasGruaService: TarifasGruaService,
    private vehiclesService: VehiclesService,
    private i18n: I18n,
    private toastr: ToastrService,
    public thisDialogRef: MatDialogRef<TarifasGruaEditorComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.tarifaGrua = Builder.newTarifaGrua();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Tancar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
   }

   ngOnInit() {

    this.tipusVehicleDictionary = new BehaviorSubject(new Array<Dictionary>());
    if (this.secure_id !== null) {
      this.tarifasGruaService.getTarifa(this.secure_id).subscribe(data => {
        this.tarifaGrua = data;
        this.loadTipusVehicle();
        this.loadTipusEstancia();
        this.loadTipusTarifa();
      });
    }else{
      this.loadTipusVehicle();
      this.loadTipusEstancia();
      this.loadTipusTarifa();
    }

  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.tarifasGruaService.setTarifa(this.tarifaGrua).subscribe(result => {
        this.toastr.info(this.i18n('Tarifa guardada correctament'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hi ha errors en el formulari!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Segur que vol esborrar la tarifa?'))
    .then((confirmed) => {
        if (confirmed) {
          this.tarifasGruaService.removeTarifa(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('tarifa esborrada correctament'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }
  loadTipusVehicle() {
    this.vehiclesService.getAllTipusVehciles().subscribe( tipusVehicles => {
      this.comboTipusVehicle.resetShowingOptions();
      if (tipusVehicles === undefined || tipusVehicles === null || tipusVehicles.length === 0) {
        this.tipusVehicleDictionary =  new BehaviorSubject(new Array<Dictionary>());
      } else {
        this.tipusVehicleDictionary =  new BehaviorSubject(new Array<Dictionary>());
          const dict = new Array<Dictionary>();
          tipusVehicles.forEach(element => {
              dict.push(new Dictionary(element.id.toString(), element.descripcio));
            });
          this.tipusVehicleDictionary.next(dict);
          if (this.tarifaGrua.tipoVehiculo !== undefined && this.tarifaGrua.tipoVehiculo !== null && this.tarifaGrua.tipoVehiculo !== '') {
            this.comboTipusVehicle.markAsTouched();
            this.comboTipusVehicle.setSelect(this.tarifaGrua.tipoVehiculo);
          }
      }
    });
  }

  tipusVehicleSeleccionado(id: string) {
    this.tarifaGrua.tipoVehiculo = id;
  }

  loadTipusEstancia() {
      this.comboTipusEstancia.resetShowingOptions();
        this.tipusEstanciaDictionary =  new BehaviorSubject(new Array<Dictionary>());
          const dict = new Array<Dictionary>();
          dict.push(new Dictionary('D', this.i18n('Dia')));
          dict.push(new Dictionary('M', this.i18n('Mes')));
          dict.push(new Dictionary('H', this.i18n('Hora')));
          this.tipusEstanciaDictionary.next(dict);
          if (this.tarifaGrua.tipoEstancia !== undefined && this.tarifaGrua.tipoEstancia !== null && this.tarifaGrua.tipoEstancia !== '') {
            this.comboTipusEstancia.markAsTouched();
            this.comboTipusEstancia.setSelect(this.tarifaGrua.tipoEstancia);
          }
  }

  tipusEstanciaSeleccionado(id: string) {
    this.tarifaGrua.tipoEstancia = id;
  }

  loadTipusTarifa() {
    this.comboTipusTarifa.resetShowingOptions();
      this.tipusTarifaDictionary =  new BehaviorSubject(new Array<Dictionary>());
        const dict = new Array<Dictionary>();
        dict.push(new Dictionary('R', this.i18n('Remolc')));
        dict.push(new Dictionary('E', this.i18n('Estància')));
        dict.push(new Dictionary('I', this.i18n('Immovilitació')));
        this.tipusTarifaDictionary.next(dict);
        if (this.tarifaGrua.tipoTarifa !== undefined && this.tarifaGrua.tipoTarifa !== null && this.tarifaGrua.tipoTarifa !== '') {
          this.comboTipusTarifa.markAsTouched();
          this.comboTipusTarifa.setSelect(this.tarifaGrua.tipoTarifa);
        }
  }

  tipusTarifaSeleccionado(id: string) {
    this.tarifaGrua.tipoTarifa = id;
  }
}
